"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConversations = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const constants_1 = require("../common/constants");
const user_1 = require("../store/selectors/user");
const character_1 = require("../slices/character");
const user_2 = require("../slices/user");
const document_1 = require("../slices/document");
const useDevice_1 = require("./useDevice");
const useRequest_1 = __importDefault(require("./useRequest"));
const useAppMessage_1 = require("./useAppMessage");
const useChatMessages_1 = require("./useChatMessages");
const useGptJourneyImage_1 = require("./useGptJourneyImage");
const character_2 = require("../services/character");
const utils_1 = require("../helper/utils");
const useConversations = () => {
    const { isTabOrDesktopDevice } = (0, useDevice_1.useDevice)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { request, customRequest } = (0, useRequest_1.default)();
    const appUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.appUser);
    const character = (0, react_redux_1.useSelector)((state) => state.getUserOptions.characterProfile);
    const conversation = (0, react_redux_1.useSelector)((state) => state.getUserOptions.conversation);
    const documents = (0, react_redux_1.useSelector)(document_1.selectDocumentsEntities);
    const characterImagesEnabled = (0, react_redux_1.useSelector)((state) => state.getUserOptions.characterImagesEnabled);
    // const storedMessages = useSelector(
    //   (state: RootState) => state.getUserOptions.storedMessages
    // );
    const fbUserId = (0, react_redux_1.useSelector)(user_1.selectfbUserId);
    const storedChatMessagesMeta = (0, react_redux_1.useSelector)((state) => state.getUserOptions.storedChatMessagesMeta);
    const storedMessages = (0, react_redux_1.useSelector)((state) => state.getUserOptions.storedMessages);
    const { showNotification } = (0, useAppMessage_1.useAppMessage)();
    const { sendEmptyMessageStream } = (0, useChatMessages_1.useChatMessages)();
    const { generateJourneyImages } = (0, useGptJourneyImage_1.useGptJourneyImage)();
    // const { refreshStoreMessages } = useCharacter();
    const pickConversation = (0, react_1.useCallback)((documentId) => {
        const document = documents[documentId];
        if (document) {
            dispatch((0, user_2.setCharacter)(document.character));
            dispatch((0, user_2.setConversation)(document.conversation));
        }
    }, [documents, dispatch]);
    const sendInitialConversationMessege = (0, react_1.useCallback)(async (selectedConversationId) => {
        const newMessageRequest = {
            message: ``,
            conversationId: selectedConversationId,
            stream: true,
        };
        const initialMessage = await sendEmptyMessageStream(selectedConversationId, JSON.stringify(newMessageRequest));
        if (constants_1.AUTOPLAY_MESSAGE_SPEECH) {
            dispatch((0, user_2.setStartVoiceAutoPlay)(initialMessage?.id));
        }
        if (fbUserId && characterImagesEnabled) {
            setTimeout(async () => {
                await generateJourneyImages(initialMessage?.message, initialMessage?.conversationId.toString(), initialMessage?.id.toString(), false);
                await handleRefreshStoreMessages(selectedConversationId);
            }, 1000);
        }
        return initialMessage;
    }, [fbUserId, characterImagesEnabled, character, dispatch]);
    const handleCreateInitialConversation = (0, react_1.useCallback)(async (characterId, isNewChat) => {
        if (!appUser?.id) {
            return;
        }
        const newConversation = await request(character_2.getOrCreateConversations, {
            userId: appUser.id,
            participantId: characterId.toString(),
            ...(isNewChat && { newChat: true }),
        });
        if (newConversation) {
            const latestChatThread = isNewChat
                ? newConversation?.data?.[newConversation?.data?.length - 1]
                : newConversation?.data?.[0];
            dispatch((0, user_2.setConversation)({ ...latestChatThread }));
        }
    }, [appUser, sendInitialConversationMessege, dispatch]);
    /**
     *
    //  */
    // const handleSetCharacterMood = useCallback(
    //   async (mood: string, selectedConversationId?: string) => {
    //     const currentConversationId = selectedConversationId || conversationId;
    //     if (currentConversationId) {
    //       const conversationDTO = { mood: mood || "" };
    //       const newConversation = await dispatch(
    //         updateConversationsAsync({
    //           id: currentConversationId || "",
    //           params: conversationDTO,
    //         })
    //       );
    //       if (newConversation?.payload && newConversation?.payload?.success) {
    //         await dispatch(setConversation(newConversation?.payload?.data || ""));
    //         dispatch(setRefreshMessages(true));
    //         setTimeout(() => {
    //           sendInitialConversationMessege(currentConversationId);
    //           // dispatch(setIsTyping(true));
    //         }, 200);
    //         console.log("Done saving mod:", {
    //           id: currentConversationId || "",
    //           params: conversationDTO,
    //         });
    //       }
    //       return newConversation;
    //     }
    //   },
    //   [conversationId]
    // );
    const refreshStoreMessages = (0, react_1.useCallback)(async (id) => {
        const messages = await dispatch((0, character_1.getConversationMessagesAsync)(id));
        if (messages?.payload?.success) {
            console.log("Store new conversation messages..DEPRECATED");
            const conversations = messages?.payload?.data;
            console.log("setStoreMessages:02 ");
            await dispatch((0, user_2.setStoredMessages)(conversations));
            await dispatch((0, user_2.setTextStreaming)(''));
        }
    }, []);
    /**
     *
     */
    // const handlSetCharacterTutorMode = useCallback(
    //   async (selectedTutorMode: boolean, selectedConversationId?: string) => {
    //     const currentConversationId = selectedConversationId || conversationId;
    //     if (currentConversationId) {
    //       const conversationDTO = { tutorMode: selectedTutorMode };
    //       let newConversation = await dispatch(
    //         updateConversationsAsync({
    //           id: currentConversationId || "",
    //           params: conversationDTO,
    //         })
    //       );
    //       if (newConversation?.payload && newConversation?.payload?.success) {
    //         await dispatch(setConversation(newConversation?.payload?.data || ""));
    //         //dispatch(setStoreMessages(allMsgswithStream));
    //         // dispatch(setRefreshMessages(true));
    //         console.log("Updated tutor mode:", {
    //           id: currentConversationId || "",
    //           params: conversationDTO,
    //         });
    //         setTimeout(async () => {
    //           sendInitialConversationMessege(currentConversationId);
    //           // Refresh messages
    //           await refreshStoreMessages(currentConversationId);
    //           // dispatch(setIsTyping(true));
    //         }, 200);
    //       } else {
    //         console.log("Tutor mode change error?");
    //       }
    //       return newConversation;
    //     }
    //   },
    //   [conversationId]
    // );
    const handleRefreshStoreMessages = (0, react_1.useCallback)(async (id) => {
        // const messages: any = await getConversationMessages(id, storedChatMessagesMeta?.limit);
        await (0, character_2.getConversationMessages)(id, storedChatMessagesMeta?.limit).then(async (messages) => {
            if (messages?.success) {
                const conversations = (0, utils_1.sortedConversations)(messages?.data);
                await dispatch((0, user_2.setStoredChatMessagesMeta)(messages?.meta));
                await dispatch((0, user_2.setStoredMessages)(conversations));
                await dispatch((0, user_2.setTextStreaming)(''));
            }
        });
    }, [
        storedChatMessagesMeta?.limit,
        storedMessages?.[storedMessages?.length - 1]?.id,
        character?.id,
        character?.attitude,
    ]);
    const selectThread = (0, react_1.useCallback)((item) => {
        if (!(conversation?.id == item?.id && isTabOrDesktopDevice)) {
            console.log("openChatThread....");
            dispatch((0, user_2.setCharacter)(item?.participant));
            dispatch((0, user_2.setConversation)(item));
            dispatch((0, user_2.setTextStreaming)(''));
            dispatch((0, user_2.setStoredMessages)([]));
            dispatch((0, user_2.setStoredChatMessagesMeta)({}));
            dispatch((0, user_2.setRefreshMessages)(true));
        }
        // On tablet we will just refresh chats
        if (!isTabOrDesktopDevice) {
        }
        else {
            dispatch((0, user_2.setRefreshMessages)(true));
        }
        return true;
    }, [conversation, isTabOrDesktopDevice]);
    return {
        pickConversation,
        // handleSetCharacterMood,
        // handlSetCharacterTutorMode,
        handleCreateInitialConversation,
        sendInitialConversationMessege,
        selectThread
    };
};
exports.useConversations = useConversations;
